import { Slide, toast, ToastOptions } from 'react-toastify';

import { Icon } from 'common/icon';

import { CustomToastProps, ToastVariant } from './types';
import { Container, CustomToastContainer } from './styles';

import 'react-toastify/dist/ReactToastify.css';

const ICON = Object.freeze({
  [ToastVariant.success]: 'check-circle',
  [ToastVariant.error]: 'warning-circle',
});

const CustomToast = (props: CustomToastProps) => {
  return (
    <CustomToastContainer variant={props.variant}>
      <Icon icon={ICON[props.variant]} />
      <p>{props.message}</p>
    </CustomToastContainer>
  );
};

export const showToast = (
  variant: CustomToastProps['variant'],
  message: CustomToastProps['message'],
  options?: ToastOptions
) => {
  return toast(<CustomToast variant={variant} message={message} />, options);
};

export const Toastify = () => {
  return (
    <Container
      limit={3}
      icon={false}
      autoClose={2000}
      draggable={false}
      transition={Slide}
      closeButton={false}
      hideProgressBar={true}
    />
  );
};
